angular.module('unergie.main')
.factory('FrontErrorCatcher', (NavigationErrors) => {
    const sendError = (error, message) => {
        const removeField = function (obj, path) {
            if (_.has(obj, path)) {
                return _.set(obj, path, undefined)
            }
            return obj
        }
        const removeFields = (paths) => (obj) => _.reduce(paths, removeField, obj)
        const removeErrorFields = removeFields([
            'config.transformRequest',
            'config.transformResponse',
            'config.headers',
            'config.data.password',
            'config.data.passwordCheck',
        ])

        // error.config.data comes in as stringified. we convert it to json to be able to remove password from the error
        if (error.config && error.config.data) {
            try {
                error.config.data = JSON.parse(error.config.data)
            } catch (err) {
                console.error('Cannot parse error.config.data', err)
            }
        }
        const idRequest = error && error.response && error.response.headers && error.response.headers['x-urg-id-req']
        console.error('ErrorCatcher', error)

        // parse error to store
        if (!idRequest && error && error.stack) {
            NavigationErrors.sendError({
                state: window.location.pathname,
                url: _.get(error, 'config.url', 'no url'),
                returnCode: error.status || _.get(error, 'response.status', null),
                error: `Erreur in view ${window.location.pathname} : ${error.stack}`,
            })
            .$promise.catch((err) => console.error('Cannot send error logging to the server', err))
        } else if (idRequest) {
            const apiResponseMessage = _.get(error, 'response.data.message', null)
            NavigationErrors.sendError({
                state: window.location.pathname,
                url: _.get(error, 'config.url', 'no url'),
                returnCode: _.get(error, 'response.status', null),
                error: _.assign({}, removeErrorFields(error.toJSON()), { idRequest, message: apiResponseMessage }),
            })
            .$promise.catch((err) => console.error('Cannot send error logging to the server', err))
        } else {
            NavigationErrors.sendError({
                state: window.location.pathname,
                url: _.get(error, 'config.url', 'no url'),
                returnCode: _.get(error, 'response.status', null),
                error: `Erreur in view ${window.location.pathname} : ${error.reason}`,
            })
            .$promise.catch((err) => console.error('Cannot send error logging to the server', err))
        }
        if (message) {
            const e = new Error(message)
            e.response = error.response
            throw e
        }
    }

    const init = () => {
        window.addEventListener('unhandledrejection', (event) => {
            // handle error here
            // event.promise contains the promise object
            // event.reason contains the reason for the rejection
            sendError(event)
        })
        window.onerror = (msg, url, lineNo, columnNo, error) => {
            const errorPayload = {
                message: msg,
                url,
                lineNo,
                columnNo,
                error,
            }
            sendError({
                stack: JSON.stringify(errorPayload),
            })
        }
    }

    init()
    return {
        sendError,
    }
})
